<script>
  import {createEventDispatcher} from 'svelte';

  import Caja from "../../UI/Caja.svelte";
  import {url} from '@sveltech/routify';

  import Boton from "../../UI/Boton.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";
  import Icono from "../../UI/Icono.svelte";
  import Tooltip from "../../UI/Tooltip.svelte";

  export let trabajador;
  export let activos;

  const dispatch = createEventDispatcher();

  const eliminarTrabajador = () => dispatch('eliminar-trabajador', trabajador);
  const restaurarTrabajador = () => dispatch('restaurar-trabajador', trabajador);
  let tooltip = false;
</script>

<style>
    .acciones {
        text-align: right;
    }

    dt, dd {
        display: inline;
        margin: 0;
        padding: 0;
    }

    dd a {
        color: currentColor;
    }

    dt {
        font-weight: 600;
    }

    dt:after {
        content: ':';
        margin-right: .5em;
    }

    dd:after {
        content: '\A';
        white-space: pre;
    }

    .nombre {
        display: flex;
        flex-direction: row-reverse;
    }

    .calendario {
        margin-right: .5em;
        position: relative;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            {#if trabajador.calendario}
                <div class="calendario" on:mouseover={() => tooltip = true}
                     on:mouseleave={() => tooltip = false}>
                    <Icono tamano="mediano" margen>calendar_today</Icono>
                    {#if tooltip}
                        <Tooltip>Tiene calendario&nbsp;propio</Tooltip>
                    {/if}
                </div>
            {/if}

            {trabajador.apellidos}, {trabajador.nombre}

            {#if trabajador.baja}
                — Baja
            {/if}
        </Subtitulo>
    </div>

    <dl>
        <dt>Código</dt>
        <dd>{trabajador.codigo}</dd>
        <dt>Teléfono</dt>
        <dd>{trabajador.telefono}</dd>
        <dt>NIF</dt>
        <dd>{trabajador.nif}</dd>
        {#if trabajador.email}
            <dt>E-mail</dt>
            <dd><a href="mailto:{trabajador.email}">{trabajador.email}</a></dd>
        {/if}
        {#if trabajador.grupo}
            <dt>Grupo</dt>
            <dd>{trabajador.grupo.nombre}</dd>
        {/if}
        {#if trabajador.sede}
            <dt>Sede</dt>
            <dd>{trabajador.sede.nombre}</dd>
        {/if}
        {#if trabajador.tarjeta}
            <dt>Tarjeta</dt>
            <dd>{trabajador.tarjeta}</dd>
        {/if}
        {#if trabajador.identificador}
            <dt>Identificador</dt>
            <dd>{trabajador.identificador}</dd>
        {/if}
    </dl>

    <div slot="pie" class="acciones">
        <Boton href={$url(`/trabajadores/${trabajador.id}`)} icono="info">Ver</Boton>
        <Boton href={$url(`/trabajadores/${trabajador.id}/editar`)} icono="edit" tipo="ok">Editar
        </Boton>
        {#if activos}
            <Boton on:click={eliminarTrabajador} icono="delete" tipo="peligro">Borrar</Boton>
        {:else}
            <Boton on:click={restaurarTrabajador} icono="restore" tipo="peligro">Restaurar</Boton>
        {/if}
    </div>
</Caja>